import secureApi from "../services/secureApi";

// LIST
export const getTaxes = async () => {
  const res = await secureApi.get("/admin/tax/list");
  return res.data;
};

// VIEW
export const getTaxById = async (id) => {
  const res = await secureApi.get(`/admin/tax/view/${id}`);
  return res.data;
};

// ADD
export const createTax = async (data) => {
  const res = await secureApi.post("/admin/tax/add", data);
  return res.data;
};

// UPDATE
export const updateTax = async (id, data) => {
  const res = await secureApi.put(`/admin/tax/edit/${id}`, data);
  return res.data;
};

// DELETE
export const deleteTax = async (id) => {
  const res = await secureApi.delete(`/admin/tax/delete/${id}`);
  return res.data;
};